// Mirrors server/app/utils/image_validation.py - keep both in sync.
// The server is the real gate; this lets the admin form reject an obviously
// bad file before the round-trip.
export const MAX_PROFILE_IMAGE_BYTES = 5 * 1024 * 1024;
export const ALLOWED_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const validateProfileImage = (file) => {
    if (file.size > MAX_PROFILE_IMAGE_BYTES) {
        const maxMb = MAX_PROFILE_IMAGE_BYTES / (1024 * 1024);
        return `Image must be ${maxMb}MB or smaller.`;
    }
    if (!ALLOWED_IMAGE_CONTENT_TYPES.includes(file.type)) {
        return `Unsupported image type. Allowed types: ${ALLOWED_IMAGE_CONTENT_TYPES.join(', ')}.`;
    }
    return null;
};
